import React, { useContext } from 'react';
import ReactGridLayout from 'react-grid-layout';
import { SizeMe } from 'react-sizeme';
import ReportsContext from '@nile/reports/src/modules/home/contexts/Reports';
import { withPlanFeatureGating } from '@nile/components';
import SectionData from '../subpages/SectionData';

const ResponsiveReactGridLayout = ReactGridLayout;
function CustomReportSheet(props) {
  const { setClient } = props;
  const layout = props?.layout?.layout;

  const reportsContext = useContext(ReportsContext);
  const condition =
    reportsContext?.reportCondition?.[reportsContext?.activeView];

  return (
    <div className="flex full-width full-height customReport min-width-1150">
      <div className="full-height full-width p10 scroll" id="reportgridlayout">
        <SizeMe monitorHeight monitorWidth>
          {({ size }) => (
            <ResponsiveReactGridLayout
              className={`layout ${layout?.length === 0 ? 'no-layout' : ''}`}
              rowHeight={30}
              cols={12}
              layout={layout}
              droppingItem={{
                i: '__droppingItem__',
                w: 6,
                h: 10
              }}
              height={size.height}
              width={size.width}
              compactType="vertical"
              measureBeforeMount
              useCSSTransforms={false}
              draggableCancel=".nonDraggable"
              preventCollision={false}
              isDroppable={false}
              isDraggable={false}
              isResizable={false}
            >
              {layout?.map((l, i) => (
                <div key={l.i} className="visibilityContainer brTransparent">
                  <SizeMe
                    monitorHeight
                    monitorWidth
                    resizeDetectorStrategy="object"
                  >
                    {({ size: childSize }) => (
                      <div
                        className={`bshadow white-to-grey-bg chart-card${i} full-height full-width`}
                        style={{
                          height: childSize.height,
                          width: childSize.width
                        }}
                      >
                        <SectionData
                          customReport
                          layoutData={l}
                          {...props}
                          condition={condition}
                          setClient={setClient}
                        />
                      </div>
                    )}
                  </SizeMe>
                </div>
              ))}
            </ResponsiveReactGridLayout>
          )}
        </SizeMe>
      </div>
    </div>
  );
}

export default withPlanFeatureGating(CustomReportSheet, {
  feature: 'CONTRACT_REPORTS',
  id: 'CustomReportSheet',
  mode: 'tease'
});
